import { OrderFlowMode } from '../_types/order-flow.types'

export const ORDER_FLOW_STEPS = {
	SELECT_AMBULANCE: 1,
	SELECT_PRODUCT: 2,
	PERSONAL_DETAILS: 3
} as const

export type OrderFlowStep = (typeof ORDER_FLOW_STEPS)[keyof typeof ORDER_FLOW_STEPS]

/** Slovak UI labels for each numeric step — single source for progress bar + any step chrome. */
export const ORDER_FLOW_STEP_LABELS = {
	[ORDER_FLOW_STEPS.SELECT_AMBULANCE]: 'Výber ambulancie',
	[ORDER_FLOW_STEPS.SELECT_PRODUCT]: 'Výber vyšetrenia',
	[ORDER_FLOW_STEPS.PERSONAL_DETAILS]: 'Údaje pacienta'
} as const satisfies Record<OrderFlowStep, string>

export type OrderFlowStepDefinition = {
	step: OrderFlowStep
	label: (typeof ORDER_FLOW_STEP_LABELS)[OrderFlowStep]
}

const STANDARD_STEP_SEQUENCE: OrderFlowStep[] = [
	ORDER_FLOW_STEPS.SELECT_AMBULANCE,
	ORDER_FLOW_STEPS.SELECT_PRODUCT,
	ORDER_FLOW_STEPS.PERSONAL_DETAILS
]

/**
 * Steps shown in the progress UI: full funnel vs direct (patient step only).
 */
export function getOrderFlowStepDefinitions(flowMode: OrderFlowMode): OrderFlowStepDefinition[] {
	if (flowMode === OrderFlowMode.DIRECT) {
		return [
			{
				step: ORDER_FLOW_STEPS.PERSONAL_DETAILS,
				label: ORDER_FLOW_STEP_LABELS[ORDER_FLOW_STEPS.PERSONAL_DETAILS]
			}
		]
	}
	return STANDARD_STEP_SEQUENCE.map(step => ({ step, label: ORDER_FLOW_STEP_LABELS[step] }))
}
